import axios from "axios";
import apiURI from "../service/Api";

// Mesmo fluxo de saída do AppTopbar
export const logout = async () => {
  const token = localStorage.getItem("__extraconomy_token");
  const deviceId = localStorage.getItem("__extraconomy_devicetoken__");

  if (deviceId) {
    try {
      await axios({
        method: "post",
        url: `${apiURI}/device/unregisterdevice`,
        data: {
          user: { username: localStorage.getItem("__extraconomy_username") },
          deviceid: JSON.parse(deviceId),
        },
        headers: { Authorization: "Bearer " + token },
      });
    } catch (e) {
      // Falha ao desregistrar o dispositivo não deve impedir a saída
    }
  }

  if (JSON.parse(localStorage.getItem("__extraconomy_ismobile__"))) {
    localStorage.removeItem("__extraconomy_token");
    window.ReactNativeWebView?.postMessage(JSON.stringify({ isLogout: true }));
  }

  localStorage.removeItem("__extraconomy_token");
  localStorage.removeItem("__extraconomy_username");
  localStorage.removeItem("__extraconomy_order");
  localStorage.removeItem("__extraconomy_order_fringe_benefit");
  window.location.replace("/login");
};
